import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.38668 6.92696C3.38618 6.83922 3.40299 6.75225 3.43617 6.67102C3.46935 6.5898 3.51823 6.51592 3.58002 6.45363C3.70493 6.32946 3.87389 6.25977 4.05002 6.25977C4.22614 6.25977 4.39511 6.32946 4.52002 6.45363L8.00002 9.92696L11.48 6.45363C11.6076 6.34441 11.7716 6.28734 11.9394 6.29382C12.1072 6.3003 12.2663 6.36986 12.3851 6.48859C12.5038 6.60732 12.5733 6.76647 12.5798 6.93426C12.5863 7.10204 12.5292 7.26609 12.42 7.39363L8.47335 11.3336C8.41106 11.3954 8.33718 11.4443 8.25595 11.4775C8.17473 11.5107 8.08775 11.5275 8.00002 11.527C7.82351 11.5245 7.65444 11.4554 7.52668 11.3336L3.58002 7.38029C3.46003 7.25942 3.39086 7.09722 3.38668 6.92696Z",
  fill: "#9899AC"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}